interface LoadingScreenProps {
  message?: string;
}

/**
 * LoadingScreen
 * ローディング中に表示するスクリーン
 */
export function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0052FF] mx-auto mb-4" />
        <p className="text-[#6B7280]" style={{ fontSize: '14px', fontWeight: 500 }}>
          {message}
        </p>
      </div>
    </div>
  );
}
